import React from "react";
import { SkeletonWrapper, SkeletonAnimation } from "./styles";
import { SkeletonProps } from "./types";

export const Skeleton: React.FC<SkeletonProps> = ({
  variant = "text",
  width = "100%",
  height,
  className,
  animationDuration = 1.5,
}) => {
  return (
    <SkeletonWrapper className={className}>
      <SkeletonAnimation
        variant={variant}
        width={width}
        height={height}
        animationDuration={animationDuration}
      />
    </SkeletonWrapper>
  );
};
